import React, { useState } from "react";
import { Typography, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { downloadTemplate } from "../../utils/downloadTemplate";
import { RiChatDownloadLine } from "react-icons/ri";
import { BookOpen, ChevronDown } from "lucide-react";

const UserGuideMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadTemplate = () => {
    downloadTemplate();
    handleClose();
  };

  const handleTechnicalGuide = () => {
    window.open("/technical-guide", "_blank");
    handleClose();
  };

  return (
    <>
      <Typography
        role="button"
        onClick={handleClick}
        sx={{
          fontSize: { xs: "10px", sm: "14px" },
          textDecoration: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          "&:hover": { textDecoration: "underline" },
        }}
      >
        <BookOpen size={20} className="text-[#bb1ccc]" />
        <span className="text-[#FFF]">User Guide</span>
        <ChevronDown
          size={20}
          className="!text-[#FFF] "
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Typography>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          onMouseLeave: handleClose,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            minWidth: "280px",
            mt: 1,
          },
        }}>
        <MenuItem
          onClick={handleDownloadTemplate}
          sx={{
            py: 1.5,
           
          }}>
          <ListItemIcon>
            <RiChatDownloadLine size={20} color="#bb1ccc" />
          </ListItemIcon>
          <ListItemText
            primary="DQ Rule Config Excel"
            primaryTypographyProps={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
            }}
          />
        </MenuItem>
        <MenuItem
          component="a"
          href="https://document-store-ui.cloud-effem.com/documentations/TOOL_DOCUMENTATION-DRAFT-DATAPULSE_PLAYBOOK/"
          target="_blank"
          rel="noreferrer"
          sx={{
            py: 1.5,
            "&:hover": {
              backgroundColor: "#f0f0ff",
            },
          }}
        >
          <ListItemIcon>
            <DescriptionIcon sx={{ color: "#bb1ccc" }} />
          </ListItemIcon>
          <ListItemText
            primary="User Playbook"
            primaryTypographyProps={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
            }}
          />
        </MenuItem>
        <MenuItem
          onClick={handleTechnicalGuide}
          sx={{
            py: 1.5,
            "&:hover": {
              backgroundColor: "#f0f0ff",
            },
          }}
        >
          <ListItemIcon>
            <MenuBookIcon sx={{ color: "#bb1ccc" }} />
          </ListItemIcon>
          <ListItemText
            primary="Technical Guide"
            primaryTypographyProps={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
            }}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserGuideMenu;
